import { taipeiDay } from '@/utils/taipeiTime';

// 日期格式化函數（列表用到分即可，不顯示秒；一律台北時間）
const formatDateTime = (date) => {
    if (!date) return '-';

    try {
        const d = taipeiDay(date);
        if (!d.isValid()) return '-';
        return d.format('YYYY-MM-DD HH:mm');
    } catch (error) {
        console.warn('formatDateTime error:', error, date);
        return '-';
    }
};

export default formatDateTime;
